import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">联系我们</h2>
          <p className="text-sm text-foreground-600 mt-3">有猛料想爆料？多种方式联系我们</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="text-center mb-8">
              <div className="w-16 h-16 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-send-line text-2xl text-accent-500"></i>
              </div>
              <h3 className="text-xl font-heading text-foreground-950">{contactInfo.title}</h3>
              <p className="text-sm text-foreground-600 mt-4 leading-relaxed max-w-lg mx-auto">
                {contactInfo.description}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <div className="flex items-center gap-3 bg-background-50 rounded-lg px-5 py-4 border border-background-200/70">
                <i className="ri-mail-line text-xl text-primary-500"></i>
                <div>
                  <div className="text-xs text-foreground-500">投稿邮箱</div>
                  <div className="text-sm font-medium text-foreground-800 mt-0.5">{contactInfo.email}</div>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-background-50 rounded-lg px-5 py-4 border border-background-200/70">
                <i className="ri-wechat-line text-xl text-secondary-500"></i>
                <div>
                  <div className="text-xs text-foreground-500">微信客服</div>
                  <div className="text-sm font-medium text-foreground-800 mt-0.5">{contactInfo.wechat}</div>
                </div>
              </div>
            </div>

            <p className="text-xs text-foreground-500 text-center mt-6">{contactInfo.tip}</p>
          </div>
        </div>
      </div>
    </section>
  );
}